import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Search } from "lucide-react";

export default function PublicLayout({ children, hideSearch = false }) {
  return (
    <div className="min-h-screen bg-[#FAFAF8] text-[#1A1A18] flex flex-col">
      <header
        className="sticky top-0 z-40 bg-white/95 backdrop-blur-xl border-b border-[#E8E6DF]"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 h-14 md:h-20 flex items-center justify-between gap-3">
          <Logo size={36} variant="horizontal" className="md:hidden" />
          <Logo size={52} variant="horizontal" className="hidden md:inline-flex" />
          {!hideSearch && (
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-3 py-2 text-sm font-semibold text-[#1A1A18] hover:text-[#B5953B] hover:bg-[#F2F0EA] rounded-sm transition-colors flex-shrink-0"
              data-testid="header-search-link"
            >
              <Search size={18} strokeWidth={2} />
              <span className="hidden sm:inline">Search</span>
            </Link>
          )}
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-[#E8E6DF] bg-white mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-xs text-[#5C5C54]">
            © {new Date().getFullYear()} Heda Plywoods · Premium plywood, crafted with precision.
          </div>
          <div className="hed-overline" style={{ fontSize: 10 }}>
            Powered by Hedaply AI
          </div>
        </div>
      </footer>
    </div>
  );
}
